/**
 * Asynchronously loads the component for HomePage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Header = lazyLoad(
  () => import('./index'),
  module => module.Header,
  {
    fallback: (
      <div className="w-full h-screen">
        <LoadingIndicator />
      </div>
    ),
  },
);
